import {
    defineCustomElements as defineIgWebComponents
}                             from "informationgrid-webcomponents/dist/loader/index";
import "./resources/style.scss"
import React                  from 'react';
import './App.css';
import {OnttrekkingenContextProvider} from "./context/OnttrekkingenContextProvider";
import MainPage                       from "./pages/MainPage";

defineIgWebComponents(window);

function App()
{
    return (
        <div className="App">
            <OnttrekkingenContextProvider>
                <MainPage/>
            </OnttrekkingenContextProvider>
        </div>
    );
}

export default App;
